import React from 'react';
import { Avatar } from 'antd';

interface ExpertAvatarProps {
  url?: string | null;
  size?: number;
}

const ExpertAvatar = function ({ url = null, size = 36 }: ExpertAvatarProps) {
  return <Avatar size={size} src={url} />;
};

export default React.memo(ExpertAvatar);
